import { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = ['places'];

const GoogleMapsContext = createContext({ isLoaded: false, hasKey: false });

export function GoogleMapsProvider({ children }) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const hasKey = !!apiKey;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey || '',
    libraries: LIBRARIES,
  });
  return (
    <GoogleMapsContext.Provider value={{ isLoaded: isLoaded && hasKey, hasKey }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
